import type { Point, Dimension, PickRequired, LoadingStatus } from 'types/common_types';
import type { CanvasConfiguration } from 'domains/canvases';
import type { CartPhoto } from 'types/photo_types';

export type SavedArrangementsSliceInitialState = {
  status: LoadingStatus;
  active: number | null;
  unavailable: UnavailableArrangement | null;
  unavailableIds: number[];
};

export type SavedArrangementCanvas = Point &
  Dimension & {
    config: PickRequired<
      CanvasConfiguration,
      'id' | 'catalog' | 'subcatalog' | 'product' | 'options'
    >;
  };

export type SavedArrangementCrop = Omit<
  CartPhoto,
  'photo_url' | 'original_filename' | 'node_id'
> & {
  canvas_id: string;
  node_uid: string;
};

export type SavedArrangement = {
  id: number;
  customer_id: string;
  preview_url: string;
  name: string;
  created_at: string;
  updated_at: string;
  height: number | null;
  width: number | null;
  canvases: SavedArrangementCanvas[];
  crops: SavedArrangementCrop[];
};

export type SavedArrangementPOSTData = Omit<
  SavedArrangement,
  'id' | 'customer_id' | 'preview_url' | 'created_at' | 'updated_at'
>;

export type CreateArrangementPayload = {
  name: string;
  includePhotos: boolean;
};

export type UpdateArrangementPayload = CreateArrangementPayload & {
  id: number;
};

export type UnavailableArrangementItem = {
  type: 'product' | 'option-group' | 'option';
  reason: 'unavailable' | 'discontinued';
  item: { id: string; name?: string; parentName?: string };
};

export type UnavailableArrangement = {
  id: number;
  items: UnavailableArrangementItem[];
};
